<template>
    <div>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group
                        class="required"
                        label="amount">
                    <b-input type="number" v-model="form.amount"></b-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group
                        class="required"
                        label="date">
                    <date-picker
                            format="YYYY-MM-DD"
                            display-format="YYYY-MM-DD"
                            locale="en" v-model="form.date"></date-picker>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="select type">
                    <b-form-select v-model="form.logType">
                        <b-form-select-option value="input">input</b-form-select-option>
                        <b-form-select-option value="output">output</b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="8">
                <b-form-group label="description">
                    <b-input v-model="form.description"></b-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group :label="this.$t('saveTitle')">
                    <b-button @click="storeStockLog" variant="success">{{$t('saveTitle')}}</b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Http from '../../../Services/HttpService/HttpService'
    import Notification from '../../../Services/Notification/Nottification'
    import {EventBus} from "../../../Services/Eventbus/event-bus";

    export default {
        name: "formStock",
        props: {
            itemId: {
                type: Number,
                default: null
            },
            logType: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                form: {
                    amount: null,
                    date: null,
                    description: null,
                    logType: 'input',
                    type: 'group'
                }
            }
        },
        methods: {
            resetFormValues() {
                this.form.amount = null;
                this.form.date = null;
                this.form.description = null;
                this.form.logType = 'input';
                this.form.type = 'group';
            },
            storeStockLog() {
                this.form.type = this.logType;
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'stock/store/' + this.itemId, this.form)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            Notification.success(response.data.message);
                            this.resetFormValues();
                            EventBus.$emit('refreshData', 'yes')
                        } else {
                            Notification.error(response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        }
    }
</script>

<style scoped>

</style>